import React, { useEffect, useState } from "react";
import CustomDataTableSearch from "../../../../partials/content/CustomDataTableSearch";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import { Badge } from "react-bootstrap";
import NumberFormat from "react-number-format";
import { formatDate } from "../../../../utils/utils";
import { getIncomingPaymentsDocRef } from "../../../../services/finance/incomingPayment";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
function SearchInPaymentDocRef({ onSelectInvoice }) {
  const { reload } = useGlobalData();
  const [invoices, setInvoices] = useState([]);
  useEffect(() => {
    getInvoiceData();
  }, [reload]);

  async function getInvoiceData() {
    const response = await getIncomingPaymentsDocRef();
    const { data } = response.data;
    setInvoices(data.invoices);
  }

  return (
    <CustomDataTableSearch
      data={invoices}
      onRefreshData={() => {
        getInvoiceData();
      }}
      onSelectedData={(rowData, originalEvent) => {
        onSelectInvoice(rowData);
      }}
      columns={[
        {
          field: "select",
          body: (rowData) => (
            <React.Fragment>
              <button
                type="button"
                className="btn btn-label-success btn-sm btn-pill btn-bold"
                onClick={() => onSelectInvoice(rowData)}
              >
                Select <i className="fas fa-angle-double-right"></i>
              </button>
            </React.Fragment>
          ),
        },
        {
          header: "A/R Invoice ID",
          field: "invoiceCode",
          body: null,
          sortable: true,
          filter: true,
        },
        {
          header: "Customer Name",
          field: "customer.customerName",
          body: (rowData) => (
            <React.Fragment>
              <ResponsiveEllipsis
                text={rowData.customer.customerName}
                maxLine="1"
              />
            </React.Fragment>
          ),
          sortable: true,
          filter: true,
        },
        {
          header: "Invoice Date",
          field: "invoiceDate",
          body: (rowData) => formatDate(rowData.invoiceDate),
          sortable: true,
          filter: true,
        },
        {
          header: "Goods Issue Status",
          field: "giStatusDesc",
          body: (rowData) => {
            if (rowData.giStatus === 1) {
              return <Badge variant="danger">{rowData.giStatusDesc}</Badge>;
            } else if (rowData.giStatus === 2) {
              return <Badge variant="warning">{rowData.giStatusDesc}</Badge>;
            } else if (rowData.giStatus === 3) {
              return <Badge variant="success">{rowData.giStatusDesc}</Badge>;
            } else {
              return <Badge variant="dark">{rowData.giStatusDesc}</Badge>;
            }
          },
          sortable: true,
          filter: true,
        },
        {
          header: "Invoice Status",
          field: "invoiceStatusDesc",
          body: (rowData) => {
            if (rowData.invoiceStatus === 1) {
              return (
                <Badge variant="danger">{rowData.invoiceStatusDesc}</Badge>
              );
            } else if (rowData.invoiceStatus === 2) {
              return (
                <Badge variant="warning">{rowData.invoiceStatusDesc}</Badge>
              );
            } else if (rowData.invoiceStatus === 3) {
              return (
                <Badge variant="success">{rowData.invoiceStatusDesc}</Badge>
              );
            } else {
              return <Badge variant="dark">{rowData.invoiceStatusDesc}</Badge>;
            }
          },
          sortable: true,
          filter: true,
        },
        {
          header: "Payment Status",
          field: "paymentStatus",
          body: (rowData) => {
            if (rowData.paymentStatus === 1) {
              return (
                <Badge variant="danger">{rowData.paymentStatusDesc}</Badge>
              );
            } else if (rowData.paymentStatus === 2) {
              return (
                <Badge variant="warning">{rowData.paymentStatusDesc}</Badge>
              );
            } else if (rowData.paymentStatus === 3) {
              return (
                <Badge variant="success">{rowData.paymentStatusDesc}</Badge>
              );
            } else {
              return <Badge variant="dark">{rowData.paymentStatusDesc}</Badge>;
            }
          },
          sortable: true,
          filter: true,
        },
        {
          header: "Currency",
          field: "currency.currencyCode",
          body: null,
          sortable: true,
          filter: true,
          hidden: true,
        },
        {
          header: "Billing Amount",
          field: "billAmount",
          body: (rowData) => (
            <NumberFormat
              value={rowData.billAmount}
              displayType={"text"}
              thousandSeparator={true}
              decimalScale={2}
              renderText={(value) => (
                <div className="float-right">
                  {rowData.currency.currencyCode} {value}
                </div>
              )}
            />
          ),
          sortable: true,
          filter: true,
        },
      ]}
    />
  );
}

export default SearchInPaymentDocRef;
